import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { GeneralMuiModal } from './general-mui-modal';

interface PdfViewerProps {
	open: boolean;
	onClose: () => void;
	pdfUrl: string;
	fileName?: string;
}

export const PdfViewer = ({ open, onClose, pdfUrl, fileName = 'Document' }: PdfViewerProps) => {
	const { t } = useTranslation();
	return (
		<GeneralMuiModal
			maxWidth="xl"
			title={fileName}
			open={open}
			onClose={onClose}
			styles={{
				paperStyle: {
					width: '90vw',
					height: '90vh',
					maxWidth: '1200px',
					maxHeight: '800px',
				},
				contentStyle: {
					padding: 0,
					display: 'flex',
					flexDirection: 'column',
					height: '100%',
				},
			}}
			content={
				<Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
					<Box sx={{ p: 2, borderBottom: '1px solid #ddd' }}>
						<Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
							{t('pdfViewer.displayProperly')}
						</Typography>
						<Button variant="outlined" size="small" onClick={() => window.open(pdfUrl, '_blank')}>
							{t('pdfViewer.openInNewTab')}
						</Button>
					</Box>
					<iframe
						src={pdfUrl}
						width="100%"
						height="100%"
						style={{ border: 'none', minHeight: '600px', flex: 1 }}
						title={fileName}
						onError={() => console.error('Failed to load PDF')}
					/>
				</Box>
			}
		/>
	);
};
